import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=09159a33&scoped=true&"
import script from "./deleteModal.vue?vue&type=script&lang=js&"
export * from "./deleteModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteModal.vue?vue&type=style&index=0&id=09159a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09159a33",
  null
  
)

export default component.exports